import { atom } from 'recoil'
import { User } from 'Types/user'
import { localStorageWriteJsonEffect } from './util'
import { storageKey } from '@/constant/storage'
import { setDeferredSentryUser } from '@/utils/deferredSentry'
import type { AppWebViewUserSyncStatus } from '@/utils/appWebView'

export const userState = atom<User | null>({
  key: 'userState',
  default: null,
  effects: [
    localStorageWriteJsonEffect(storageKey.USER),
    ({ onSet }) => {
      onSet((newUser) => {
        setDeferredSentryUser(newUser?.user_id ? { id: newUser.user_id } : null)
      })
    },
  ],
})

// App WebView may inject a partial user snapshot. Keep user-driven UI gated
// until /user/info has had one chance to replace it with the backend profile.
export const appWebViewUserSyncStatusState = atom<AppWebViewUserSyncStatus>({
  key: 'appWebViewUserSyncStatusState',
  default: 'idle',
})

export const translateCharacterState = atom<string[]>({
  key: 'translateCharacterState',
  default: [],
})

export const newUserRightsState = atom<boolean>({
  key: 'newUserRightsState',
  default: false,
})

export const languageInitState = atom<boolean>({
  key: 'languageInitState',
  default: false,
})

export const screenParamsState = atom<{
  gender?: string
  nsfw?: boolean
  language?: string
} | null>({
  key: 'screenParamsState',
  default: null,
})

export const showCharNumState = atom<number>({
  key: 'showCharNumState',
  default: 0,
})
